import { Component, OnInit } from '@angular/core';
import { RouterPathService } from "../../../../core/common/variables/router-path.service";
import { TranslateService } from "../../../common/variables/translate-service";
import { ImagePathService } from "../../../common/variables/image-path.service";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GeneratorToolComponent } from "./generator-tool/generator-tool.component";
import { SC_Input } from '../../../common/input/SC_Input';
import { GlobalVariableService } from '../../../common/variables/global-variable';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { GlobalService } from '../../../common/services/global.service';
import InverterStringCanvas from "../../../common/inverterString/InverterStringCanvas";
import * as _ from 'lodash';
import ColorLib from '../../../common/lib/ColorLib';
import { ActivatedRoute, Router } from '@angular/router';
import { Global } from '../../../common/utilities/global';
import { SenLoaderService } from '../../../common/loader/sen-loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'sen-app-stringing',
  templateUrl: './stringing.component.html',
  styleUrls: ['./stringing.component.scss']
})
export class StringingComponent implements OnInit {
  prevPath: string;
  nextPath: string;
  beamColorCode: string = "#000";
  selectedInverter: any = SC_Input.sInverter;
  selectedProject$: Observable<any[]>;
  panelDrawn$: Observable<any[]>;
  panelDrawn: any = 0;
  selectedProjectArray: any;
  selectedProjectUnSubscribe: Subscription;
  arrayOfRoofItems: any = []
  canvasDraw: InverterStringCanvas;
  enableDragLayout: any = true;
  manulDraw: any = true;
  completedStrLine: any[] = [];
  disableNextBtn: boolean = true;
  inverterStrings: any = [];
  collapseIndex: number = 1;
  collapseIndex$: Observable<any[]>;
  collapseIndexunSubscribe: Subscription;
  constructor(private routerPath: RouterPathService,
    private store: Store<any>,
    private _snackBar: MatSnackBar,
    public global: GlobalVariableService,
    public globalService: GlobalService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: SenLoaderService,
    // private route: ActivatedRoute,
    public translate: TranslateService,
    public imagePath: ImagePathService) {
    this.prevPath = `..${this.routerPath.pathSeperator}${this.routerPath.IPCustomizeString}`;
    this.nextPath = `..${this.routerPath.pathSeperator}${this.routerPath.IPAcdcString}`;
    this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
    this.selectedProjectUnSubscribe = this.selectedProject$.subscribe(data => {
      this.selectedProjectArray = cloneDeep(data);
      if (this.selectedProjectArray.roofPlans) {
        this.getAllPlanData()
      }
    });
    this.canvasDraw = new InverterStringCanvas(store);
    this.collapseIndex$ = this.store.select(state => {
      return state.appData.collapseIndex
    });
    this.collapseIndexunSubscribe = this.collapseIndex$.subscribe((data: any) => {
      this.collapseIndex = data.collapseIndex;
    });
  }

  ngOnInit(): void {
    this.panelDrawn$ = this.store.select(state => { return state.appData });
    this.panelDrawn$.subscribe((data: any) => {
      if (data && data.panelsDrawn && data.panelsDrawn.panelsDrawn >= 0) {
        this.panelDrawn = data.panelsDrawn.panelsDrawn;
        this.completedStrLine = this.canvasDraw.completedStrLine;
        this.canvasDraw.completedPanelCount = this.panelDrawn;
      }
    });
    let subGenerators = [...this.selectedInverter.subGenerators];
    this.selectedInverter.subGenerators = _.sortBy(subGenerators, 'name');
    this.selectedInverter.subGenerators.forEach((subG: any) => {
      let a: any = [];
      if (subG.strings)
        a = [...subG.strings];
      a.forEach((item: any) => {
        item.drawn = false;
      });
      subG.strings = _.sortBy(a, 'name');
    });
    Global.stringName = this.translate.getLng('INV_STRING');
  }

  ngOnDestroy() {
    this.selectedProjectUnSubscribe.unsubscribe();
  }

  onchangeBeamColor(color: string) {
  }

  triggerGeneratorTool(s: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      buttons: {
        cancel: this.translate.getLng('OK')
      },
      color: s.color
    };
    dialogConfig.disableClose = true;
    dialogConfig.width = '22vw';
    dialogConfig.maxWidth = '280px';
    dialogConfig.position = { top: '10vh', left: '55vw' }
    let dialogRef = this.dialog.open(GeneratorToolComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((color: string) => {
      s.color = color;
      this.updateColor(s);
      dialogRef.close();

    });
  }

  updateColor(s: any) {
    let percentColor = 0.2;
    if (s.name.indexOf(this.translate.getLng('INV_STRING')) > -1) {
      const strName = s.name.replace(" ", "_");
      this.strColorupdate(strName.toLowerCase(), s.color);
    } else {
      s.strings.forEach((item: any, ind: number) => {
        const color = ColorLib.shadeColor(s.color, percentColor)
        item.color = color;
        const strName = item.name.replace(" ", "_");
        this.strColorupdate(strName.toLowerCase(), color);
        if (ind % 4 == 0) { // at every 4th step it reset color to orignal since the color dilution makes the color to white
          percentColor = 0.2;
        } else {
          percentColor += 0.2;
        }
      });
    }
    this.canvasDraw.stringLayer.draw();
  }

  strColorupdate(strName: string, color: string) {
    const line: any = this.canvasDraw.stringLayer.find("." + strName);
    line[0].setStroke(color);
    this.canvasDraw.updateStringLines(this.selectedInverter);
    const groups: any = this.canvasDraw.stringLayer.find("." + strName + "_group");
    groups.forEach((group: any) => {
      const child: any = group.getChildren().toArray();
      child.forEach((ch: any) => {
        if (ch.getClassName() == "Circle") {
          ch.setFill(color);
        }
      });
    });
  }

  processRoofData() {
    let observableBatch: any = [];
    this.selectedProjectArray.roofPlans.forEach((p: any) => {
      // filtering roof planes if there is diff. panelId
      if (this.selectedProjectArray.panelID == p.panelID)
        observableBatch.push(this.globalService.getData({ cmd: this.global.RoofPlanGet, id: p.id }));
    });
    return forkJoin(observableBatch);
  }

  getAllPlanData() {
    this.processRoofData()
      .subscribe(data => {
        this.arrayOfRoofItems = data;
        // console.log(this.arrayOfRoofItems); // temp1[0].ok.data.panelRows
        this.drawCanvasInverter();
      })
  }

  drawCanvasInverter() {
    const position: any = document.getElementById("inverter_canvas_container");
    this.canvasDraw.render("canvasInverter", position, this.arrayOfRoofItems);
  }

  zoomFit() {
    // this.loaderService.isLoading.next(true);
    this.canvasDraw.zoomFit();
  }
  autoDrawStrings() {
    this.canvasDraw.autoDrawStrings(this.selectedInverter);
  }

  clearStrings() {
    this.canvasDraw.clearStrings();
    this.completedStrLine = [];
    this.canvasDraw.completedStrLine = [];
    // this.loaderService.isLoading.next(false);
  }
  manualDraw() {
    // this.canvasDraw.stage.setDraggable(false);
    this.enableDragLayout = false;
    this.canvasDraw.stage.setDraggable(this.enableDragLayout);
    if (this.panelDrawn == 0)
      this.canvasDraw.updateStringLines(this.selectedInverter);
    this.canvasDraw.drawingEnabled();
    const image: any = document.getElementById("colorBgForImage");
    console.log(image.classList);
    this.manulDraw = !this.manulDraw;
    if (!this.manulDraw) {
      image.classList.add("sen-activebg-image")
    } else {
      image.classList.remove("sen-activebg-image")
    }
    this.canvasDraw.stage.draw();
  }
  enableDrag() {
    this.enableDragLayout = !this.enableDragLayout;
    this.canvasDraw.stage.setDraggable(this.enableDragLayout);
    this.canvasDraw.stage.draw();
  }
  genarateImagesForPdf() {
    this.canvasDraw.zoomFit();
    // const f: any = this.canvasDraw.scale;
    // this.canvasDraw.stage.height(this.canvasDraw.stage.height() * f);
    this.canvasDraw.stage.height(this.canvasDraw.backgroundHeight);
    // const overviewStringing = this.canvasDraw.stage.toDataURL({ "pixelRatio": 1, height: InverterStringCanvas.totalHeight * InverterStringCanvas.appliedScale });
    const overviewStringing = this.canvasDraw.stage.toDataURL({ "pixelRatio": 1 });
    Global.OverviewImage = overviewStringing;
    // this.inverterStrings.push({ "overview": overviewStringing });
    // const overviewStringing = this.canvasDraw.stage.toDataURL({ "pixelRatio": 1 });
    // this.downloadURI(overviewStringing, 'stage.png');
    this.subGenaratorLevelPdf();
    this.goNext2();
  }

  subGenaratorLevelPdf() {
    const listOfSubGens: any = {};
    SC_Input.sInverter.subGenerators.forEach((subGen: any) => {
      const strs: any = [];
      subGen.strings.forEach((line: any) => {
        strs.push(line.name.replace(" ", "_"));
      });
      listOfSubGens[subGen.name] = strs;
    });
    // console.log(listOfSubGens)
    Object.keys(listOfSubGens).forEach((gen: any) => {
      const strs: any[] = listOfSubGens[gen];
      strs.forEach((str: any) => {
        const a: any = this.canvasDraw.stringLayer.find("." + str);
        a.forEach((s: any) => {
          s.setOpacity(0);
        });
        const b: any = this.canvasDraw.stringLayer.find("." + str + "_group");
        b.forEach((s: any) => {
          s.setOpacity(0);
        });
      })
    });
    Object.keys(listOfSubGens).forEach((s: string) => {
      this.subGenPdf(listOfSubGens, s);
    })
  }

  subGenPdf(listOfSubGens: any, subGen: string) {
    Object.keys(listOfSubGens).forEach((gen: any) => {
      const strs: any[] = listOfSubGens[gen];
      let num = 0;
      if (gen == subGen) num = 1;
      strs.forEach((str: any) => {
        const a: any = this.canvasDraw.stringLayer.find("." + str);
        a.forEach((s: any) => {
          s.setOpacity(num);
        });
        const b: any = this.canvasDraw.stringLayer.find("." + str + "_group");
        b.forEach((s: any) => {
          s.setOpacity(num);
        });
      })
    });
    // const overviewStringing = this.canvasDraw.stage.toDataURL({ "pixelRatio": 1, height: InverterStringCanvas.totalHeight * InverterStringCanvas.appliedScale });
    const overviewStringing = this.canvasDraw.stage.toDataURL({ "pixelRatio": 1});
    // const obj: any = {};
    // obj[index] = overviewStringing
    this.inverterStrings.push(overviewStringing);
    // this.downloadURI(overviewStringing, subGen+'.png');
  }
  downloadURI(uri: any, name: any) {
    var link = document.createElement('a');
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // delete link;
  }
  goNext() {
    if (this.panelDrawn && this.selectedInverter.panelCount != this.panelDrawn) {
      // TODO: Improve placeholder
      let message = this.translate.getLng('STRING_PANEL_COUNT_MESSAGE').replace('{CONNECTED_PANEL}', this.panelDrawn).replace('{ALL_PANEL_COUNT}', this.selectedInverter.panelCount);
      this._snackBar.open(message);
      return;
    }
    const canvas = document.getElementById("inverter_canvas_container");
    if (canvas) canvas.style.filter = "blur(10px)";
    this.loaderService.isLoading.next(true);
    const displayonImgCal: any = document.getElementById("displayonImgCal");
    displayonImgCal.style.top = '39%';

    this.inverterStrings = [];
    setTimeout(() => {
      this.goNext1();
    }, 1);
  }
  goNext1() {
    setTimeout(() => {
      this.genarateImagesForPdf();
    }, 1);
  }
  goNext2() {
    this.canvasDraw.stringLines.forEach((stringLine: any) => {
      SC_Input.sInverter.subGenerators.forEach((subGen: any) => {
        if (subGen.name == stringLine.string.subGenName) {
          subGen.strings.forEach((line: any, index: number) => {
            if (line.name == stringLine.string.name) {
              line.nodes = stringLine.string.nodes;
              line.drawn = true;
              line.color = stringLine.string.color;
            }
          })
        }
      })
    });
    Global.inverterStrings = this.inverterStrings;
    Global.SubGenImage = this.inverterStrings;
    // console.log(SC_Input.sInverter.subGenerators);
    setTimeout(() => {
      this.router.navigate([this.nextPath], { relativeTo: this.route });
    }, 1000)
  }
}
